import Image from 'next/image'
import Link from 'next/link'
import { Form } from 'react-final-form'

import { useConnect } from 'wagmi'

import Notification from '@infura/packages.components/Notification'
import { Button } from '@infura/packages.ui/Button'

import { LOGIN_METHOD_NAME } from 'lib/constants'
import { Infura } from 'lib/types/infuraTypes'

const Separator = () => (
  <div className='my-6'>
    <div className='relative'>
      <div aria-hidden='true' className='absolute inset-0 flex items-center'>
        <div className='border-border-default w-full border-t' />
      </div>
      <div className='relative flex justify-center text-sm font-medium leading-6'>
        <span className='bg-background-alternative text-text-alternative px-5'>or</span>
      </div>
    </div>
  </div>
)

const WalletLoginForm = ({ onSubmit }) => {
  const { connectors } = useConnect()
  const connector = connectors.find(c => ['MetaMask Flask', 'MetaMask'].includes(c.name))

  if (!connector)
    return (
      <>
        <Link
          className='hover:shadow-hover border-border-muted text-text-alternative inline-flex w-full items-center justify-center border py-3 no-underline hover:bg-white hover:no-underline'
          href='https://metamask.io/download/'
          target='_blank'
        >
          <Image alt='MetaMask icon' className='mr-1.5 h-4 w-4' height='16' src='svg/icons/MetaMask.svg' width='16' />
          <span className='text-sm uppercase tracking-widest'>Install MetaMask</span>
        </Link>
        <Separator />
      </>
    )

  return (
    <Form
      initialValues={{ authLoginMethod: Infura.AUTH_LOGIN_METHOD.WALLET }}
      onSubmit={onSubmit}
      render={({ handleSubmit, submitError, submitting }) => {
        return (
          <form className='xxl:text-lg text-base' data-testid='auth-form' onSubmit={handleSubmit}>
            {submitError ? (
              <Notification className='mb-6' color='alert' data-testid='auth-form-error' size='sm' variant='outlined'>
                <span className='w-full text-center'>{submitError}</span>
              </Notification>
            ) : null}
            <Button
              className=' '
              data-testid='mm-auth-button'
              disabled={submitting}
              fullWidth
              id='mm-auth-button'
              loading={submitting}
              onClick={() => {
                if (window.analytics) {
                  window.analytics.track('Login Initiated', {
                    login_method: 'Metamask',
                    timestamp: Date.now(),
                    user_experience: 'B'
                  })
                }
                sessionStorage.setItem(LOGIN_METHOD_NAME, 'Metamask')
              }}
              theme='secondary'
              type='submit'
            >
              <span className='flex items-center justify-center'>
                <Image
                  alt='MetaMask icon'
                  className='mr-1.5 h-4 w-4'
                  height='16'
                  src='svg/icons/PrimaryMetaMask.svg'
                  width='16'
                />
                Continue with MetaMask
              </span>
            </Button>
            <Separator />
          </form>
        )
      }}
    />
  )
}
export default WalletLoginForm
